import React, { useState, useEffect } from 'react';
import { IonContent, IonPage, IonCardContent, IonCard } from '@ionic/react';
import { AppointmentStepProps } from '../../navigators/AppointmentNavigator';
import Stepper from '../../components/Stepper';
import AppHeader from '../../components/AppHeader';
import { AppointmentsRootState } from '../../store/reducers/appointments';
import { connect } from 'react-redux';
import FormHormonologie, {
  OptionalFormData,
  optionalFormName as hormonologieOptionalFormName
} from '../checkinSteps/FormHormonologie';
import { Laboratory } from '../../models';
import { setOptionalFormData } from '../../store/actions/appointments';

const mapStateToProps = (
  state: { appointments: AppointmentsRootState },
  ownProps: any
) => {
  return {
    laboratory: state.appointments.appointment.laboratory
  };
};

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  setOptionalFormData: (formKey: string, data: OptionalFormData) =>
    dispatch(setOptionalFormData(formKey, data))
});

type Props = AppointmentStepProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> & {
    isUploadMandatory: boolean;
    isCovid: boolean;
    titleLabel: string;
    subtitleLabel: string;
    continueButtonLabel: string;
  };

const SpecialityForms: React.FC<Props> = ({
  step,
  history,
  nextStepRouterLink = '/',
  isCovid = false,
  laboratory,
  stepperComponent = <Stepper step={step} />,
  setOptionalFormData
}) => {
  const [allOptionalForms, setAllOptionalForms] =
    useState<{ form: Laboratory['checkin_forms'][number] }[]>();

  useEffect(() => {
    const optionalForms: typeof allOptionalForms = [];

    if (laboratory?.checkin_forms?.length) {
      laboratory.checkin_forms.forEach((form) => {
        optionalForms.push({
          form
        });
      });
    }

    if (optionalForms.length) {
      setAllOptionalForms(optionalForms);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [laboratory]);

  const [showHormonologieOptionalForm, setShowHormonologieOptionalForm] =
    useState(false);

  useEffect(() => {
    if (!allOptionalForms) {
      return;
    }

    if (allOptionalForms.length === 0) {
      history.push(nextStepRouterLink);
    } else if (allOptionalForms.length) {
      if (allOptionalForms[0].form === hormonologieOptionalFormName) {
        setShowHormonologieOptionalForm(true);
      } else {
        onOptionalFormSuccess();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allOptionalForms?.length]);

  function onOptionalFormSuccess(key?: string, data?: OptionalFormData) {
    if (key && data) {
      setOptionalFormData(key, data);
    }

    setAllOptionalForms(allOptionalForms?.slice(1));
  }

  return (
    <IonPage>
      <AppHeader />
      {stepperComponent}
      <IonContent>
        <div className="wrapper wrapper--large wrapper--centered">
          <IonCard>
            <IonCardContent>
              {showHormonologieOptionalForm && (
                <FormHormonologie onSuccess={onOptionalFormSuccess} />
              )}
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SpecialityForms);
